var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gh-sidebar__detail" }, [
    _c(
      "header",
      { staticClass: "gh-sidebar__header gh-sidebar__header--detail" },
      [
        _c("div", { staticClass: "gh-sidebar__detail-heading" }, [
          _c(
            "button",
            {
              staticClass: "gh-sidebar__back-icon",
              attrs: { type: "button" },
              on: { click: _vm.backToList },
            },
            [
              _c("img", {
                staticClass: "gh-sidebar__back-icon-img",
                attrs: { src: _vm.iconArrowLeft, alt: "" },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.detail
            ? _c(
                "h2",
                { staticClass: "gh-sidebar__detail-title" },
                [
                  _vm.serviceNameKey
                    ? [
                        _vm._v(
                          _vm._s(_vm.$t(_vm.serviceNameKey)) + "\n          "
                        ),
                        _c(
                          "span",
                          { staticClass: "gh-sidebar__detail-title--count" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.displayCardCount) +
                                _vm._s(
                                  _vm.$t("generation_history.count_suffix")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "gh-sidebar__close",
            attrs: { type: "button" },
            on: { click: _vm.closeSidebar },
          },
          [_c("span", [_vm._v("×")])]
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "gh-sidebar__body gh-sidebar__body--detail" }, [
      _vm.downloadLoading
        ? _c("div", { staticClass: "gh-sidebar__download-loading" }, [
            _c("i", {
              staticClass: "fa fa-spinner fa-spin",
              attrs: { "aria-hidden": "true" },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.detailLoading && !_vm.detail
        ? _c("div", { staticClass: "gh-sidebar__loading" }, [
            _c("i", {
              staticClass: "fa fa-spinner fa-spin",
              attrs: { "aria-hidden": "true" },
            }),
          ])
        : _vm.detailError
        ? _c("div", { staticClass: "gh-sidebar__error" }, [
            _vm._v(_vm._s(_vm.detailError)),
          ])
        : _vm.detail
        ? _c(
            "div",
            { ref: "cardsEl", staticClass: "gh-sidebar__cards" },
            _vm._l(_vm.displayCards, function (card, cardIndex) {
              return _c(_vm.detailCardComponent, {
                key: _vm.getConceptDisplayCardKey(card),
                tag: "component",
                attrs: {
                  card: card,
                  "card-index": cardIndex,
                  "project-type": _vm.detail.project_type,
                  collapsed: _vm.isCardCollapsed(cardIndex),
                  "is-copied": _vm.isCopySuccess(card, "text"),
                  "is-image-copied": _vm.isCopySuccess(card, "image"),
                  "is-prompt-copied": _vm.isCopySuccess(card, "prompt"),
                },
                on: {
                  "toggle-collapse": function ($event) {
                    return _vm.toggleCard(cardIndex)
                  },
                  copy: function ($event) {
                    return _vm.onCopyText(card)
                  },
                  "copy-image": function ($event) {
                    return _vm.onCopyImage(card, $event)
                  },
                  "copy-prompt": function ($event) {
                    return _vm.onCopyPrompt(card)
                  },
                  download: function ($event) {
                    return _vm.onDownload(card, cardIndex)
                  },
                  favorite: function ($event) {
                    return _vm.onToggleFavorite(card, cardIndex)
                  },
                },
              })
            }),
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }